<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized">
  <!-- <div *ngIf="courses?.length == 0" class="text-center">
    <h3>You have not purchased any courses yet</h3>
    <h5>Head to the <a class="text-primary" [routerLink]="['/course-library']">library</a> to browse!</h5>
  </div> -->

  <h4>My Library</h4>
  <div class="row mb-2">
    <div class="col">
      <div class="d-block d-md-flex">
        <select class="form-control mr-2 mb-1" [(ngModel)]="searchParams.certifyingBodyId" (change)="search(true)">
          <option [ngValue]="null">CEU Type: Any</option>
          <option *ngFor="let tag of filterData.ceuTypes" value="{{ tag.value }}">{{ tag.name }}</option>
        </select>

        <select class="form-control mr-2 mb-1" [(ngModel)]="searchParams.conferenceId" (change)="search(true)">
          <option [ngValue]="null">Conference: Any</option>
          <option *ngFor="let conf of filterData.conferences" value="{{ conf.value }}">{{ conf.name }}</option>
        </select>

        <select class="form-control mr-2 mb-1" [(ngModel)]="searchParams.watched" (change)="search(true)">
          <option [ngValue]="null">Watched: Any</option>
          <option [ngValue]="true">Did Watch</option>
          <option [ngValue]="false">Did NOT Watch</option>
        </select>

        <select class="form-control mb-1" [(ngModel)]="searchParams.completedCEUs" (change)="search(true)">
          <option [ngValue]="null">CEU Completion: Any</option>
          <option [ngValue]="true">Did Complete CEUs</option>
          <option [ngValue]="false">Did NOT Complete CEUs</option>
        </select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="input-group mb-3">
        <input type="text" class="form-control" placeholder="Search by title, presenter, CEU type or ID..." (keyup.enter)="search(true)" [(ngModel)]="searchParams.query" />
        <div class="input-group-append">
          <button class="btn btn-outline-danger" type="button" (click)="searchParams.query = ''; search(true)">Clear</button>
          <button class="btn btn-outline-secondary" type="button" (click)="search(true)">Search</button>
        </div>
      </div>
    </div>
  </div>
  <div class="">
    <ng-container *ngIf="searching">
      <div *ngFor="let item of [].constructor(20)" class="mb-2">
        <p-skeleton width="100%" height="100px"></p-skeleton>
      </div>
    </ng-container>
    <div *ngIf="!searching" class="row">
      <div class="col-lg-12">
        <ng-container *ngFor="let course of courses; let idx=index;">
          <div *ngIf="idx%5 == 0 || idx == 0 " class="mt-1 mb-5">
            <ad-display [isMargin]="false"></ad-display>
          </div>
          <bxl-course-item  [course]="$any(course)" [displayPrice]="false"></bxl-course-item>


        </ng-container>
      </div>
    </div>

    <p-paginator *ngIf="courses && courses.length > 0" [rows]="this.searchParams.pageSize" [first]="this.searchParams.page * this.searchParams.pageSize" [totalRecords]="resultCount" (onPageChange)="paginate($event)" [rowsPerPageOptions]="[10, 20, 30, 50]"></p-paginator>
    <div class="row no-gutters no-candidates" style="height: 300px" *ngIf="!searching && courses && courses.length == 0">
      <div class="col-sm-12 my-auto">
        <h1><i class="fas fa-empty-set"></i></h1>
        <h4>No Results</h4>
        <p>Please modify your search and try again.</p>
        <h5>Or head to the <a class="text-primary" [routerLink]="['/course-library']">library</a> to browse!</h5>

      </div>
    </div>
    <div class="py-3"></div>
  </div>
</div>
